import { useQuery } from '@tanstack/react-query'
import { getLocationFromPlace } from './services'

export const useGetLocationFromPlace = place => {
  const query = useQuery(
    ['locationFromPlace', place],
    () => getLocationFromPlace(place),
    {
      enabled: !!place,
      retry: 1,
    }
  )

  return {
    ...query,
    isLoading: query.isLoading && query.fetchStatus !== 'idle',
    isLoadingOnly: query.isLoading,
  }
}
